import React, { useEffect, useState } from 'react'
import { useAnalytics } from '@shared/data/Analytics'
import { useEffectiveUser } from '@shared/data'

declare global {
  interface Window {
    $zopim: any
  }
}

export const Zendesk: React.FC = () => {
  const { data, isSuccess } = useAnalytics()
  const [injected, setInjected] = useState(false)
  const user = useEffectiveUser()

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' || window.parent !== window.self.window) {
      return
    }
    if (!injected && isSuccess && data && user) {
      setInjected(true)
      const zendeskUrl = data!.zendesk?.url
      const username = user?.givenName + ' ' + user?.familyName

      window.$zopim ||
        (function (d, s) {
          const z = (window.$zopim = function (c: any) {
            // @ts-expect-error vendor snippet pushes onto a queue it hangs off the $zopim function itself
            z._.push(c)
          })
          // @ts-expect-error vendor snippet stores the injected script element on the $zopim function
          const $ = (z.s = d.createElement(s))
          const e = d.getElementsByTagName(s)[0]
          // @ts-expect-error vendor snippet hangs set() off the $zopim function
          z.set = function (o) {
            // @ts-expect-error vendor snippet queues set() calls on set's own array
            z.set._.push(o)
          }
          // @ts-expect-error vendor snippet initialises the $zopim call queue
          z._ = []
          // @ts-expect-error vendor snippet initialises the set() call queue
          z.set._ = []
          // @ts-expect-error createElement is typed as HTMLElement, which has no async
          $.async = !0
          $.setAttribute('charset', 'utf-8')
          // @ts-expect-error createElement is typed as HTMLElement, which has no src
          $.src = zendeskUrl
          // @ts-expect-error vendor snippet stamps a load timestamp on the $zopim function
          z.t = +new Date()
          // @ts-expect-error createElement is typed as HTMLElement, which has no type
          $.type = 'text/javascript'
          // @ts-expect-error the first script tag always has a parent node at this point
          e.parentNode.insertBefore($, e)

          // Zopim chat set user credentials
          window.$zopim(function () {
            window.$zopim.livechat.setName(username)
            window.$zopim.livechat.setEmail(user?.email)
            window.$zopim.livechat.theme.setColor('#3142BD')
            window.$zopim.livechat.bubble.setColor('#3142BD')
            window.$zopim.livechat.button.setColor('#3142BD')
            window.$zopim.livechat.button.setOffsetHorizontal(80)
            window.$zopim.livechat.theme.reload()
          })
        })(document, 'script')
    }
  }, [injected, data, isSuccess, user])

  return null
}
